import "./App.css";
import { useEffect, useState } from "react";
import Layout from "./components/layout";
import { getChartsData, getNotes } from "./data/data.facade";
import { AuthenticationContext } from "./contexts/authentication";
import "bootstrap/dist/css/bootstrap.min.css";
import { AccessContext } from "./contexts/access";
import { RoutesContext } from "./contexts/routes";
import { ChartsDataContext } from "./contexts/chartsData";
import { SelectedFeatureContext } from "./contexts/selectedFeature";
import { SelectedPeriodContext } from "./contexts/selectedPeriod";
import axios from "axios";
import { HistoryContext } from "./contexts/history";
import { IntroductionContext } from "./contexts/introduction";
function App() {
  const [authentication, setAuthentication] = useState({
    username: "",
    token: "",
    loggedIn: false,
  });
  const [access, setAccess] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState(0);
  const [selectedPeriod, setSelectedPeriod] = useState(0);
  const [chartsData, setChartsData] = useState([]);
  const [history, setHistory] = useState([]);
  const [introductionData, setIntroductionData] = useState([]);
  const authenticationValue = {
    dispatch: (username = "", token = "", loggedIn = false) =>
      setAuthentication({
        username,
        token,
        loggedIn,
        logginTime: Date.now(),
      }),
    value: authentication,
  };
  const accessValue = {
    dispatch: (access) => setAccess(access),
    value: access,
  };
  const RoutesValue = {
    dispatch: (routes) => setRoutes(routes),
    value: routes,
  };
  const selectedFeatureValue = {
    dispatch: (key) => {
      if (key === undefined) return;
      setSelectedFeature(key);
      setSelectedPeriod(0);
    },
    value: selectedFeature,
  };
  const selectedPeriodValue = {
    dispatch: (key) => setSelectedPeriod(key),
    value: selectedPeriod,
  };
  const chartsDataValue = {
    dispatch: (key) => setChartsData(key),
    value: chartsData,
  };
  const IntroductionValue = {
    dispatch: (key) => setIntroductionData(key),
    value: introductionData,
  };
  const historyValue = {
    push: (route) => {
      const temp = history;
      temp.push(route);
      setHistory(temp);
    },
    pop: () => {
      const temp = history;
      const value = temp.pop();
      setHistory(temp);
      return value;
    },
    value: history,
  };

  useEffect(() => {
    if (!authentication.loggedIn) return undefined;

    const cancelToken = axios.CancelToken.source();
    getChartsData(cancelToken.token)
      .then((response) => {
        setChartsData(response);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) console.error(error);
      });

    return () => {
      cancelToken.cancel();
    };
  }, [authentication.loggedIn]);
  useEffect(() => {
    if (!authentication.loggedIn) return undefined;

    const cancelToken = axios.CancelToken.source();
    getNotes(cancelToken.token)
      .then((response) => {
        setIntroductionData(response);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) console.error(error);
      });

    return () => {
      cancelToken.cancel();
    };
  }, [authentication.loggedIn]);

  return (
    <AuthenticationContext.Provider value={authenticationValue}>
      <AccessContext.Provider value={accessValue}>
        <RoutesContext.Provider value={RoutesValue}>
          <SelectedFeatureContext.Provider value={selectedFeatureValue}>
            <SelectedPeriodContext.Provider value={selectedPeriodValue}>
              <ChartsDataContext.Provider value={chartsDataValue}>
                <HistoryContext.Provider value={historyValue}>
                  <IntroductionContext.Provider value={IntroductionValue}>
                    <Layout />
                  </IntroductionContext.Provider>
                </HistoryContext.Provider>
              </ChartsDataContext.Provider>
            </SelectedPeriodContext.Provider>
          </SelectedFeatureContext.Provider>
        </RoutesContext.Provider>
      </AccessContext.Provider>
    </AuthenticationContext.Provider>
  );
}

export default App;
